<template>
    <div class="column is-4-desktop">
        <form>
            <div class="field">
                <label class="label">User Deposit</label>
                <div class="control has-icons-left">
                    <input v-bind:disabled="isSalesStaff" class="input" :class="{ 'is-loading': isLoadingDeposit }"
                           type="number" v-model="deposit.amount" v-on:change="updateDeposit"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-wallet"></i>
                    </span>
                </div>
            </div>
            <user-settings v-if="!isSalesStaff" :user="user"></user-settings>
        </form>
    </div>
</template>

<script>
    import apiUsers from '../../../api/apiUsers'
    import userSettings from './UserSettings.vue'

    export default {
        props: ['balance', 'user'],
        components: {
            userSettings
        },
        data() {
            return {
                deposit: {
                    user_id: this.balance.user_id,
                    amount: this.balance.amount
                },
                isLoadingDeposit: false,
                isLoading: false,
            }
        },
        methods: {
            updateDeposit() {
                this.isLoadingDeposit = true
                apiUsers
                    .userDepositUpdateRequest(this.deposit)
                    .then((response) => {
                        this.isLoadingDeposit = false
                        this.$store.dispatch('addTransaction', response.data.original)
                    })
                    .catch((error) => {

                    })
            }
        },
        mounted() {
            this.deposit.amount = this.balance.amount
            this.deposit.user_id = this.balance.user_id
        },
        computed: {
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserDeposit.vue